import type { SpreadType, Topic } from './types';

export const SPREAD_CHURU_COSTS: Record<SpreadType, number> = {
  'one-card': 10,
  'three-card': 15,
  'celtic-cross': 20,
};

export const WALLET_RECHARGE_INTENT_KEY = 'ny_wallet_recharge_intent';

export interface SelectionRechargeIntent {
  type: 'selection';
  spread: SpreadType;
  topic: Topic;
  question: string;
  requiredPoints: number;
}

export interface ReadingRechargeIntent {
  type: 'reading';
  readingId: string;
  replayToken: string;
  spread: SpreadType;
  requiredPoints: number;
}

export type WalletRechargeIntent = SelectionRechargeIntent | ReadingRechargeIntent;

export function getSpreadChuruCost(spread: SpreadType): number {
  return SPREAD_CHURU_COSTS[spread];
}

export function getSpreadLabel(spread: SpreadType): string {
  switch (spread) {
    case 'one-card':
      return '원카드';
    case 'three-card':
      return '쓰리카드';
    case 'celtic-cross':
      return '켈틱 크로스';
    default:
      return '리딩';
  }
}

export function saveWalletRechargeIntent(intent: WalletRechargeIntent) {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(WALLET_RECHARGE_INTENT_KEY, JSON.stringify(intent));
}

export function readWalletRechargeIntent(): WalletRechargeIntent | null {
  if (typeof window === 'undefined') return null;

  const raw = window.sessionStorage.getItem(WALLET_RECHARGE_INTENT_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as WalletRechargeIntent;
    if (!parsed || typeof parsed !== 'object' || !('type' in parsed)) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearWalletRechargeIntent() {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(WALLET_RECHARGE_INTENT_KEY);
}

export function persistReadingSelection(spread: SpreadType, topic: Topic, question: string) {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem('selected_spread', spread);
  window.sessionStorage.setItem('selected_theme', topic);
  window.sessionStorage.setItem('selected_question', question);
  window.localStorage.setItem('myoan_has_started_reading', '1');
}

export function getSelectionRoute(spread: SpreadType, topic: Topic): string {
  return `/stitch/selection?theme=${encodeURIComponent(topic)}&spread=${spread}`;
}
